export var KEY_NAMES = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  TAB: 'Tab'
};